import { CurrencyUtils } from "@indeed/frontend-i18n-utils";

export function parseLocaleCurrencyAmount(amount: string, locale: string) {
  let formattedAmount: number;
  try {
    formattedAmount = CurrencyUtils.parseCurrencyWithLocale(amount || "0", locale);
  } catch {
    // invalid locale
    try {
      formattedAmount = CurrencyUtils.parseCurrencyWithLocale(amount || "0", "en-US");
    } catch {
      // invalid amount
      formattedAmount = Number.NaN;
    }
  }

  return formattedAmount;
}
